/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Guest_Field_TitleInputs */

const vi_meeting_guest_field_title = /** @type {(inputs: Meeting_Guest_Field_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chức vụ`)
};

/**

* @param {Meeting_Guest_Field_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const meeting_guest_field_title = /** @type {((inputs?: Meeting_Guest_Field_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Guest_Field_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_meeting_guest_field_title(inputs)
});